import { render, staticRenderFns } from "./childorder.vue?vue&type=template&id=35b7ca67&scoped=true&"
import script from "./childorder.vue?vue&type=script&lang=js&"
export * from "./childorder.vue?vue&type=script&lang=js&"
import style0 from "./childorder.vue?vue&type=style&index=0&id=35b7ca67&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7ca67",
  null
  
)

export default component.exports